
<template>
    <div class="p-fluid p-grid">
      <div class="p-col-12 p-md-6">
        <canvas id="target-achievement-bar"></canvas>
      </div>
      <div class="p-col-12 p-md-6">
        <canvas id="target-achievement-line"></canvas>
      </div>
    </div>
</template>
  
<script>
import Chart from 'chart.js'

export default {
  name: 'Chart',
  data() {
    return {
    }
  },
  mounted() {
    this.createChart()
  },
  methods: {
    async createChart() {
      await this.planetChartDataTargetAchievement()
    },
    async planetChartDataTargetAchievement() {
      let resp = await this.$store.dispatch('loadTargetAchievementBar')
      console.log(resp)
      const ctxBar = document.getElementById('target-achievement-bar')
      const ctxLine = document.getElementById('target-achievement-line')
      new Chart(ctxBar, {
        type: 'bar',
        data: resp,
        options: {
          scales: {
            y: {
              beginAtZero: true
            }
          }
        }
      })
      new Chart(ctxLine, {
        type: 'line',
        data: resp,
        options: {
          scales: {
            y: {
              beginAtZero: true
            }
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// salesTargetReportGraph.vue?192b2b0e